import React from 'react';

import SignatureAttachmentModal from './SignatureAttachmentModal';
import SignatureModal from './SignatureModal';

import NavigationComponent from '../../../commonComponents/util/NavigationComponent';
import LoadingSpinner from '../../../commonComponents/util/LoadingSpinner';

export default class Signatures extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = {
            showModals: {
                signaturePreviewModal: false,
                signatureModal: false
            },
            attachment: {
                source: '',
                name: ''
            },
            editSignature: {
                fundId: null,
                fundName: ''
            }
        };
    }

    async viewAttachment(fileId, attachmentName) {
        this.setState({ attachment: { source: `/api/settings/signatures/${fileId}`, name: attachmentName } }, () => this.toggleModal('signaturePreviewModal'))
    }

    editFundSignature(fundId, fundName) {
        this.setState({ editSignature: { fundId, fundName } }, () => this.toggleModal('signatureModal'));
    }

    render() {        
        return (
            <div className="relative">
                {this.props.loading && <div className="signature-spinner"><LoadingSpinner height="32" /></div>}
                <div className="flex-justify flex-center signature-label">
                    <label className="input-label">Signature</label>
                    <a className="link-text xs-text" onClick={this.toggleModal.bind(this, 'signatureModal')}>Add New</a>
                </div>
                {this.props.signatures.map((signature, index) =>
                    <div className="signature" key={index}>
                        <p className="medium-text">{signature.fundName}</p>
                        <p className="accent-text small-text">{signature.fileName}</p>
                        <div className="signature-actions">
                            <i className="icon ion-eye accent-text" onClick={this.viewAttachment.bind(this, signature.fileId, signature.fileName)}/>
                            <i className="icon ion-ios-upload accent-text" onClick={this.editFundSignature.bind(this, signature.fundId, signature.fundName)}/>
                        </div>
                    </div>
                )}
                <SignatureAttachmentModal
                    show={this.state.showModals.signaturePreviewModal}
                    source={this.state.url}
                    close={this.toggleModal.bind(this, "signaturePreviewModal")}
                    attachment={this.state.attachment} />

                <SignatureModal 
                    show={this.state.showModals.signatureModal}
                    fundId={this.state.editSignature.fundId}
                    fundName={this.state.editSignature.fundName}
                    close={() => {
                        this.setState({ editSignature: {} }, () => this.toggleModal('signatureModal'))
                    }}
                    addSignature={this.props.addSignature}
                    reloadPaymentSettings={this.props.reloadPaymentSettings}
                    loading={this.props.adding.loading}
                    success={this.props.adding.success}
                    funds={this.props.funds.filter(f => this.props.signatures.map(s => s.fundId).indexOf(f.key) < 0)} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/paymentSettings/Signatures.jsx